// extracted by mini-css-extract-plugin
export default {"tmpl-tab-ul":"Detail_tmpl-tab-ul__3kQln","action-icon":"Detail_action-icon__Vz+Cn"};